import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemButton from '@mui/material/ListItemButton';
import { RouterLink } from 'src/routes/components';
import { fUntilNow } from 'src/utils/format-time';
import { CONFIG } from 'src/global-config';
import { useTranslate } from 'src/locales';
import { Label } from 'src/components/label';
import { Iconify } from 'src/components/iconify';
import { FileThumbnail } from 'src/components/file-thumbnail';

// ----------------------------------------------------------------------

export function NotificationItem(t0) {
  const $ = _c(58);
  const {
    collection,
    notification,
    handleMarkAsRead
  } = t0;
  const {
    t
  } = useTranslate();
  const [isUnRead, setIsUnRead] = useState(notification.isUnRead);
  if (!(collection === "unread" && isUnRead || collection === "all")) {
    return null;
  }
  let t1;
  if ($[0] !== handleMarkAsRead || $[1] !== notification.id) {
    t1 = () => {
      setIsUnRead(false);
      handleMarkAsRead?.(notification.id);
    };
    $[0] = handleMarkAsRead;
    $[1] = notification.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const onHandleMarkAsRead = t1;
  let t2;
  if ($[3] !== notification.avatarUrl || $[4] !== notification.type) {
    t2 = () => <ListItemAvatar>{notification.avatarUrl === null ? <Box sx={{
        width: 42,
        height: 42,
        display: "grid",
        borderRadius: "50%",
        placeItems: "center",
        backgroundColor: "background.neutral"
      }}><Box component="img" src={`${CONFIG.assetsDir}/assets/icons/notification/ic-${notification.type}.svg`} sx={{
          width: 25,
          height: 25
        }} /></Box> : <Avatar src={notification.avatarUrl} />}</ListItemAvatar>;
    $[3] = notification.avatarUrl;
    $[4] = notification.type;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const renderAvatar = t2;
  let t3;
  if ($[6] !== notification.createdAt || $[7] !== notification.title) {
    t3 = () => <ListItemText disableTypography={true} primary={reader(notification.title, {
      maxWidth: {
        xs: 0.88,
        md: 0.8
      }
    })} secondary={<Box sx={{
      display: "flex",
      alignItems: "center",
      typography: "caption",
      color: "text.disabled"
    }}>{fUntilNow(notification.createdAt.toDate())}</Box>} />;
    $[6] = notification.createdAt;
    $[7] = notification.title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const renderText = t3;
  let t4;
  if ($[9] !== isUnRead || $[10] !== onHandleMarkAsRead || $[11] !== t) {
    t4 = () => <Box sx={{
      top: 16,
      right: 16,
      position: "absolute"
    }}><Tooltip title={t(isUnRead ? "Mark as read" : "Readed")}><IconButton color={isUnRead ? "inherit" : "info"} onClick={() => isUnRead && onHandleMarkAsRead()} sx={{
          color: isUnRead ? "text.disabled" : "info.main"
        }}><Iconify icon="eva:done-all-fill" /></IconButton></Tooltip></Box>;
    $[9] = isUnRead;
    $[10] = onHandleMarkAsRead;
    $[11] = t;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const renderUnReadBadge = t4;
  let t5;
  if ($[13] !== notification.action || $[14] !== t) {
    t5 = (t6, t7) => {
      const title = t6 === undefined ? "View" : t6;
      const variant = t7 === undefined ? "contained" : t7;
      return <Box sx={{
        gap: 1,
        mt: 1.5,
        display: "flex"
      }}><Button size="small" variant={variant} component={RouterLink} href={notification.action}>{t(title)}</Button></Box>;
    };
    $[13] = notification.action;
    $[14] = t;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const renderAction = t5;
  const renderFriendAction = _temp;
  const renderProjectAction = _temp2;
  const renderFileAction = _temp3;
  const renderValueAction = _temp4;
  let t6;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = [_temp5];
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== renderUnReadBadge) {
    t7 = renderUnReadBadge();
    $[17] = renderUnReadBadge;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== renderAvatar) {
    t8 = renderAvatar();
    $[19] = renderAvatar;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      flexGrow: 1
    };
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== renderText) {
    t10 = renderText();
    $[22] = renderText;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== notification.type || $[25] !== renderAction) {
    t11 = notification.type === "order" && renderAction("View order");
    $[24] = notification.type;
    $[25] = renderAction;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== notification.type || $[28] !== renderAction) {
    t12 = notification.type === "payment" && renderAction("See transfer");
    $[27] = notification.type;
    $[28] = renderAction;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== notification.type || $[31] !== renderAction) {
    t13 = notification.type === "social" && renderAction("View profile", "outlined");
    $[30] = notification.type;
    $[31] = renderAction;
    $[32] = t13;
  } else {
    t13 = $[32];
  }
  let t14;
  if ($[33] !== notification.type || $[34] !== renderAction) {
    t14 = notification.type === "referred" && renderAction("View profile", "outlined");
    $[33] = notification.type;
    $[34] = renderAction;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== notification.type) {
    t15 = notification.type === "friend" && renderFriendAction();
    $[36] = notification.type;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  let t16;
  if ($[38] !== notification.type) {
    t16 = notification.type === "project" && renderProjectAction();
    $[38] = notification.type;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== notification.type) {
    t17 = notification.type === "file" && renderFileAction();
    $[40] = notification.type;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== notification.type) {
    t18 = notification.type === "tags" && renderValueAction();
    $[42] = notification.type;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t10 || $[45] !== t11 || $[46] !== t12 || $[47] !== t13 || $[48] !== t14 || $[49] !== t15 || $[50] !== t16 || $[51] !== t17 || $[52] !== t18) {
    t19 = <Box className="stack" sx={t9}>{t10}{t11}{t12}{t13}{t14}{t15}{t16}{t17}{t18}</Box>;
    $[44] = t10;
    $[45] = t11;
    $[46] = t12;
    $[47] = t13;
    $[48] = t14;
    $[49] = t15;
    $[50] = t16;
    $[51] = t17;
    $[52] = t18;
    $[53] = t19;
  } else {
    t19 = $[53];
  }
  let t20;
  if ($[54] !== t19 || $[55] !== t7 || $[56] !== t8) {
    t20 = <ListItemButton disableRipple={true} sx={t6}>{t7}{t8}{t19}</ListItemButton>;
    $[54] = t19;
    $[55] = t7;
    $[56] = t8;
    $[57] = t20;
  } else {
    t20 = $[57];
  }
  return t20;
}
function _temp5(theme) {
  return {
    p: 2.5,
    alignItems: "flex-start",
    borderBottom: `dashed 1px ${theme.vars.palette.divider}`
  };
}
function _temp4() {
  return <Box sx={{
    mt: 1.5,
    gap: 0.75,
    display: "flex",
    flexWrap: "wrap"
  }}><Label variant="outlined" color="info">Design</Label><Label variant="outlined" color="warning">Dashboard</Label><Label variant="outlined">Design system</Label></Box>;
}
function _temp3() {
  return <Box sx={{
    pl: 1,
    gap: 1,
    p: 1.5,
    mt: 1.5,
    display: "flex",
    borderRadius: 1.5,
    backgroundColor: "background.neutral"
  }}><FileThumbnail file="http://localhost:8080/httpsdesign-suriname-2015.mp3" /><Box sx={{
      gap: 1,
      flexGrow: 1,
      minWidth: 0,
      display: "flex",
      flexDirection: {
        xs: "column",
        sm: "row"
      }
    }}><ListItemText disableTypography={true} primary={<Box className="noWrap" sx={{
        color: "text.secondary",
        typography: "subtitle2"
      }}>design-suriname-2015.mp3</Box>} secondary={<Stack divider={<Box sx={{
        mx: 0.5,
        width: 2,
        height: 2,
        borderRadius: "50%",
        backgroundColor: "currentColor"
      }} />} sx={{
        alignItems: "center",
        flexDirection: "row",
        typography: "caption",
        color: "text.disabled"
      }}><span>2.3 GB</span><span>30 min ago</span></Stack>} /><Button size="small" variant="outlined">Download</Button></Box></Box>;
}
function _temp2() {
  return <><Box sx={{
      p: 1.5,
      my: 1.5,
      borderRadius: 1.5,
      color: "text.secondary",
      backgroundColor: "background.neutral"
    }}>{reader("<p><strong>@Jaydon Frankie</strong> feedback by asking questions or just leave a note of appreciation.</p>")}</Box><Button size="small" variant="contained" sx={{
      alignSelf: "flex-start"
    }}>Reply</Button></>;
}
function _temp() {
  return <Box sx={{
    gap: 1,
    mt: 1.5,
    display: "flex"
  }}><Button size="small" variant="contained">Accept</Button><Button size="small" variant="outlined">Decline</Button></Box>;
}
function reader(data, sx) {
  return <Box dangerouslySetInnerHTML={{
    __html: data
  }} sx={[{
    mb: 0.5,
    '& p': {
      typography: 'body2',
      m: 0
    },
    '& strong': {
      typography: 'subtitle2'
    },
    '& a': {
      color: 'inherit',
      textDecoration: 'none'
    }
  }, ...(Array.isArray(sx) ? sx : [sx])]} />;
}